import { useQuery } from '@tanstack/react-query';
import { ROUTES } from '../routes';
import { api } from '../client';
import { useAuthStore } from '../../store/authStore';
import type { IncidenteOperacional } from '../../types/models';

/**
 * Hook para Incidentes Operacionais.
 * GET /escolas/:escolaId/incidentes-operacionais
 */
export function useIncidentes(filters?: { status?: string; severidade?: string }) {
  const escolaId = useAuthStore((s) => s.escolaId);

  const query = useQuery({
    queryKey: ['incidentes-operacionais', escolaId, filters],
    queryFn: async () => {
      const { data } = await api.get(ROUTES.incidentes.porEscola(escolaId!), {
        params: filters,
      });
      // API devolve { items, total } (mesmo padrão de chamadas)
      const list = Array.isArray(data)
        ? data
        : (data?.items ?? data?.data ?? []);
      return list as IncidenteOperacional[];
    },
    enabled: !!escolaId,
    refetchInterval: 60_000, // Atualiza a cada 1 min
  });

  const list = query.data ?? [];
  const ativo = (s?: string) => {
    const st = String(s || '').toUpperCase();
    return st === 'ABERTO' || st === 'EM_ANALISE';
  };

  return {
    incidentes: list,
    isLoading: query.isLoading,
    /** Abertos + em análise (alinha com risco-evasão / fila operacional). */
    abertos: list.filter((i) => ativo(i.status)).length,
    criticos: list.filter(
      (i) => i.severidade === 'CRITICA' && ativo(i.status),
    ).length,
  };
}
